import { createContext, ReactElement, ReactNode, useMemo } from "react";

import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { Guid } from "@/Common/Models/Guid";

interface EmployeeContextType {
    getFullNameWithPrefixContactFacet: (employeeContacFacettId: Guid) => string;
}

const EmployeeContext = createContext<EmployeeContextType | undefined>(undefined);

interface EmployeeContextProviderProps {
    children: ReactNode;
}

function EmployeeContextProvider({ children }: Readonly<EmployeeContextProviderProps>): ReactElement {
    const employeeContextValue = useMemo(() => ({ getFullNameWithPrefixContactFacet: Employee.getFullNameWithPrefixContactFacet }), []);

    return (
        <EmployeeContext.Provider value={employeeContextValue}>
            {children}
        </EmployeeContext.Provider>
    );
}

export {
    EmployeeContext,
    EmployeeContextProvider,
    EmployeeContextType
};
